import React from 'react';
import AddEditCustomerForm from 'ui-component/AddEditCustomerForm';


function AddCustomer() {
  return (
    <div>
      <AddEditCustomerForm title="Add Customer" />
    </div>
  );
}

export default AddCustomer;
